import styled from "styled-components";

export const AGModalWraper = styled.div`
	.required {
    display: flex;
    color: #ae1515;
    font-size: 0.9375rem;
    gap: 5px;
  	}
	.label-title {
    font-weight: 700;
    display: flex;
    align-items: center;
    padding: 0px 20px 8px 0px;
    word-wrap: break-word;
    color: #333;
    font-family: Segoe UI, Segoe WP, Tahoma, Arial, sans-serif;
    font-size: 0.875rem;
    line-height: 1.3;
    max-width: 100%;
    position: relative;
    white-space: pre-wrap;
    .tool-tip {
      font-size: 0.875rem !important;
      font-weight: 400;
      max-width: 300px;
      a {
        font-weight: 700;
      }
    }
    .wraptitle {
      display: flex;
      gap: 5px;
      align-items: center;
    }
    .add-new {
      font-weight: 400;
    }
    &.flex {
      padding-right: 3px;
      @media only screen and (max-width: 650px) {
        button {
          gap: 0;
        }
        .add-new {
          display: none;
        }
      }
    }

    &.tow-col-label {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;
      input[type="checkbox"] {
      }
    }
    &.pb-0 {
      padding-bottom: 0 !important;
    }
  }
`;
